module.exports = __webpack_public_path__ + "static/media/ucla_logo.564ec9ab.jpg";